export default {
	"superAddressComp": {
		"pickUpPoint": "Pickup point"
	},
	"tempSpanComp": {
		"noLimit": "Unlimited"
	},
	"searchComp": {
		"orderNo": " ",
		"transportNo": " ",
		"taskNo": " ",
		"originNo": " ",
		"transferNo": " ",
		"routeNo": " "
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/components/searchComponent/searchComponent.js